// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_6l-4";
export var collapsed = "_6l-1";
export var headerBar = "_6l-0";
export var leftHeaderContent = "_6l-3";
export var subjectContainer = "_6l-2";